module.exports = ".sub-title {\r\n  border-bottom: 2px solid cornflowerblue;\r\n  padding: 20px;\r\n}\r\n\r\n.nav.nav-tabs {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  padding: 0 15px;\r\n}\r\n\r\n.nav.nav-tabs > li {\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1;\r\n          flex: 1;\r\n}\r\n\r\n.block.no-padding {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.block-content .block-content {\r\n  padding-top: 0;\r\n}\r\n\r\n.nav-subtitle.no-padding {\r\n  padding: 0 24px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/fly-out/fly-out.component.css
// module id = ./src/app/shared/components/fly-out/fly-out.component.css
// module chunks = main